import { Link } from "react-router-dom";
import { Mail, AlertTriangle } from "lucide-react";

const Footer = () =>
<footer className="border-t border-border bg-card">
    <div className="container-wide px-4 py-12 md:px-8">
      <div className="grid gap-8 md:grid-cols-3">
        {/* Brand */}
        <div className="flex flex-col gap-3">
          <Link to="/" className="flex items-center gap-3">
            <img src="/images/logo.jpeg" alt="Logo Centro Arcipelago" className="h-10 w-10 object-contain" />
            <span className="font-serif text-lg font-semibold text-foreground">Centro Arcipelago</span>
          </Link>
          <p className="mt-1 max-w-xs text-sm text-muted-foreground">
            Equipe clinica multidisciplinare per la cura della corporeità sintomatica.
          </p>
        </div>

        {/* Navigation */}
        <nav className="flex flex-col gap-2">
          <p className="mb-1 text-sm font-semibold text-foreground">Navigazione</p>
          <Link to="/" className="text-sm text-muted-foreground transition-colors hover:text-primary">La nostra visione</Link>
          <Link to="/chi-siamo" className="text-sm text-muted-foreground transition-colors hover:text-primary">Chi siamo</Link>
          <Link to="/di-cosa-ci-occupiamo" className="text-sm text-muted-foreground transition-colors hover:text-primary">Di cosa ci occupiamo</Link>
          <Link to="/contatti" className="text-sm text-muted-foreground transition-colors hover:text-primary">Contatti</Link>
        </nav>

        {/* Contact */}
        <div className="flex flex-col gap-4">
          <div>
            <p className="mb-1 text-sm font-semibold text-foreground">Contatti</p>
            <a href="mailto:info@centroarcipelago.it" className="inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary">
              <Mail size={14} /> info@centroarcipelago.it
            </a>
          </div>
          <div className="flex items-start gap-2 rounded-lg bg-destructive/10 p-3">
            <AlertTriangle size={14} className="mt-0.5 shrink-0 text-destructive" />
            <p className="text-xs text-muted-foreground">
              Per urgenze/emergenze rivolgersi ai servizi di emergenza (112 / 118).
            </p>
          </div>
        </div>
      </div>

      {/* ESOMAR badge */}
      <div className="mt-8 flex items-center justify-center gap-3">
        <a href="https://www.esomar.org" target="_blank" rel="noopener noreferrer">
          
        </a>
      </div>

      <div className="mt-6 border-t border-border pt-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Centro Arcipelago — Tutti i diritti riservati.
      </div>
    </div>
  </footer>;


export default Footer;